export const SCROLL_TO = 'SCROLL_TO';

type TPayload = {
    categoryName: string,
}

export const scrollTo = (payload: TPayload) => ({
    type: SCROLL_TO,
    payload
})